"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var extension_link_1 = __importDefault(require("@tiptap/extension-link"));
var extension_placeholder_1 = __importDefault(require("@tiptap/extension-placeholder"));
var extension_underline_1 = __importDefault(require("@tiptap/extension-underline"));
var react_2 = require("@tiptap/react");
var starter_kit_1 = __importDefault(require("@tiptap/starter-kit"));
var react_3 = require("react");
var LinkInput_1 = __importDefault(require("./LinkInput"));
var Menu_1 = require("./Menu");
var getCSSRules = function (_a) {
    var colors = _a.colors;
    return ({
        error: {
            color: colors.Red[600],
        },
        rte: {
            paddingBottom: 5,
            '& .ProseMirror': {
                fontSize: 18,
                lineHeight: '26px',
                minHeight: 100,
                color: colors.Grey[900],
                '&:focus': { outline: 'none' },
                '& p.is-editor-empty:first-of-type::before': {
                    color: colors.Grey[500],
                    content: "attr(data-placeholder)",
                    float: 'left',
                    height: 0,
                    pointerEvents: 'none',
                },
            },
        },
        disabled: {
            '& .ProseMirror': {
                color: colors.Grey[300],
            },
        },
    });
};
var RichTextEditor = function (_a) {
    var actions = _a.actions, className = _a.className, content = _a.content, disabled = _a.disabled, error = _a.error, hideMenu = _a.hideMenu, initialContent = _a.initialContent, menuChildren = _a.menuChildren, onChange = _a.onChange, placeholder = _a.placeholder, readOnly = _a.readOnly, rest = __rest(_a, ["actions", "className", "content", "disabled", "error", "hideMenu", "initialContent", "menuChildren", "onChange", "placeholder", "readOnly"]);
    var _b = (0, react_3.useState)(false), showLink = _b[0], setShowLink = _b[1];
    var CustomLink = extension_link_1.default.extend({
        addKeyboardShortcuts: function () {
            return {
                'mod-k': function () {
                    setShowLink(true);
                    return true;
                },
            };
        },
    });
    var editor = (0, react_2.useEditor)({
        content: initialContent || content,
        editable: !readOnly && !disabled,
        extensions: [
            CustomLink.configure({ openOnClick: true }),
            starter_kit_1.default,
            extension_underline_1.default,
            extension_placeholder_1.default.configure({
                placeholder: placeholder,
            }),
        ],
    });
    (0, react_3.useEffect)(function () {
        if (!!content && !!editor && editor.getHTML() !== content) {
            editor.commands.setContent(content);
        }
    }, [content, editor]);
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme);
    (0, react_3.useEffect)(function () {
        if (editor) {
            if (onChange) {
                editor.on('update', function (_a) {
                    var editor = _a.editor;
                    return onChange(editor.getHTML());
                });
            }
            editor.on('selectionUpdate', function () { return setShowLink(false); });
        }
    }, [editor]);
    var linkInput = (0, react_3.useMemo)(function () {
        if (editor && showLink) {
            return (0, jsx_runtime_1.jsx)(LinkInput_1.default, { onToggleView: setShowLink, editor: editor }, void 0);
        }
    }, [showLink, editor]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className, css: (0, react_1.css)(styles.rte, error && styles.error, disabled && styles.disabled) }, rest, { children: [!hideMenu && editor && !readOnly && ((0, jsx_runtime_1.jsx)(Menu_1.Menu, __assign({ actions: actions, disabled: disabled, editor: editor, linkInput: linkInput, toggleShowLink: setShowLink }, { children: menuChildren }), void 0)), (0, jsx_runtime_1.jsx)(react_2.EditorContent, { editor: editor }, void 0)] }), void 0));
};
exports.default = RichTextEditor;
//# sourceMappingURL=index.js.map